import HarmonyHubLogo from '../components/HarmonyHubLogo'
import HDHLogo from '../components/HDHLogo'

export default function LogoTest() {
  return (
    <div className="min-h-screen bg-black text-white p-8">
      <h1 className="text-4xl font-bold mb-8 text-center">Logo Test Page</h1>
      
      <div className="max-w-4xl mx-auto space-y-12">
        {/* Harmony Hub Logo Tests */}
        <section className="text-center">
          <h2 className="text-2xl font-bold mb-6 text-gold-500">Harmony Hub Logo</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Small</h3>
              <div className="flex justify-center">
                <HarmonyHubLogo size="sm" variant="full" className="text-white" />
              </div>
            </div>
            
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Medium</h3>
              <div className="flex justify-center">
                <HarmonyHubLogo size="md" variant="full" className="text-white" />
              </div>
            </div>
            
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Large</h3>
              <div className="flex justify-center">
                <HarmonyHubLogo size="lg" variant="full" className="text-white" />
              </div>
            </div>
          </div>
          
          <div className="bg-gray-800 p-6 rounded-lg">
            <h3 className="text-lg font-semibold mb-4">Extra Large</h3>
            <div className="flex justify-center">
              <HarmonyHubLogo size="xl" variant="full" className="text-white" />
            </div>
          </div>
        </section>
        
        {/* HDH Logo Tests */}
        <section className="text-center">
          <h2 className="text-2xl font-bold mb-6 text-purple-400">HDH Logo</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Small</h3>
              <div className="flex justify-center">
                <HDHLogo size="sm" variant="full" className="text-white" />
              </div>
            </div>
            
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Medium</h3>
              <div className="flex justify-center">
                <HDHLogo size="md" variant="full" className="text-white" />
              </div>
            </div>
            
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Large</h3>
              <div className="flex justify-center">
                <HDHLogo size="lg" variant="full" className="text-white" />
              </div>
            </div>
          </div>
          
          <div className="bg-gray-800 p-6 rounded-lg">
            <h3 className="text-lg font-semibold mb-4">Extra Large</h3>
            <div className="flex justify-center">
              <HDHLogo size="xl" variant="full" className="text-white" />
            </div>
          </div>
        </section>
        
        {/* Variant Tests */}
        <section className="text-center">
          <h2 className="text-2xl font-bold mb-6 text-blue-400">Logo Variants</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Full Variant</h3>
              <div className="flex justify-center mb-4">
                <HarmonyHubLogo size="md" variant="full" className="text-white" />
              </div>
              <div className="flex justify-center">
                <HDHLogo size="md" variant="full" className="text-white" />
              </div>
            </div>
            
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Icon Variant</h3>
              <div className="flex justify-center mb-4">
                <HarmonyHubLogo size="md" variant="icon" className="text-white" />
              </div>
              <div className="flex justify-center">
                <HDHLogo size="md" variant="icon" className="text-white" />
              </div>
            </div>
            
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-lg font-semibold mb-4">Text Variant</h3>
              <div className="flex justify-center mb-4">
                <HarmonyHubLogo size="md" variant="text" className="text-white" />
              </div>
              <div className="flex justify-center">
                <HDHLogo size="md" variant="text" className="text-white" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
